import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  db,
  collection,
  query,
  getDocs,
  getUserDataById,
  getDoc,
  doc,
  where,
} from "../utils/firebase/firebase.utils";
import avatar from "../assets/images/avatar.jpeg";
import {
  NOTIFICATION_TYPE_BALANCE_ACCEPTED,
  NOTIFICATION_TYPE_BALANCE_REJECTED,
  NOTIFICATION_TYPE_BID_ACCEPTED,
  NOTIFICATION_TYPE_BID_PRICE_COUNTER,
  NOTIFICATION_TYPE_BID_PRICE_FIRST,
  NOTIFICATION_TYPE_BID_REJECTED,
  NOTIFICATION_TYPE_COMMENT_PRODUCT,
  NOTIFICATION_TYPE_COMMENT_REPLY,
  NOTIFICATION_TYPE_FOLLOW,
  NOTIFICATION_TYPE_LIKE_PRODUCT,
  NOTIFICATION_TYPE_ORDER_DELIVERED,
  NOTIFICATION_TYPE_PRICE_DROP,
  NOTIFICATION_TYPE_PRODUCT_ACCEPTED,
  NOTIFICATION_TYPE_PRODUCT_AUTHENTICATING,
  NOTIFICATION_TYPE_PRODUCT_AUTHENTICATING_FAILED,
  NOTIFICATION_TYPE_PRODUCT_DELIVERED,
  NOTIFICATION_TYPE_PRODUCT_DRIVER_PICKUP,
  NOTIFICATION_TYPE_PRODUCT_ORDER_PLACED,
  NOTIFICATION_TYPE_PRODUCT_PRICE_DROP,
  NOTIFICATION_TYPE_PRODUCT_REJECTED,
  NOTIFICATION_TYPE_PRODUCT_SHIPPED,
  NOTIFICATION_TYPE_BALANCE_UPDATED,
} from "../constants/constants";
import {
  DeleteAllOrderProduct,
  GetAllOrderProduct,
} from "../features/Order/OrderSlice";
import { async } from "@firebase/util";
import React, { useEffect, useState } from "react";
import { GetAllUsers } from "../features/Products/ProductSlice";

function NotificationMap({ notifications, currentUser, setShow }) {
  console.log(notifications, "noty");
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const { users } = useSelector((store) => store.allproducts);
  console.log(users, "On production");
  const [prod, setProd] = useState([]);
  const [productsrRej, setProductsrRej] = useState([]);

  const [prodsplit1, setProdsplit1] = useState([]);

  const yourListingOrdered =
    i18n.language == "en" ? "You sold an item!" : "لقد قمت ببيع منتج!";
  const yourListingRejected =
    i18n.language == "en"
      ? "The item you listed wasn't approved for publishing this time!"
      : "لم تتم الموافقة على نشر منتجك هذه المرة!";
  const yourListingAccepted =
    i18n.language == "en"
      ? "Your listing is approved!"
      : "تمت الموافقة على منتجك!";
  const yourListingPickup =
    i18n.language == "en"
      ? "The courier is on the way to pick up your item."
      : "سائق التوصيل في الطريق لاستلام منتجك.";
  const yourListingAuthenticate =
    i18n.language == "en"
      ? "We are authenticating your item."
      : "نحن نقوم بمصادقة منتجك.";
  const yourListingAuthenticateFail =
    i18n.language == "en"
      ? "We checked your item and it didn't meet the requirements."
      : "لقد تحققنا من منتجك ولم يستوفِ المتطلبات.";
  const yourListingShipped =
    i18n.language == "en" ? "Your item is shipped." : "تم شحن منتجك.";
  const yourListingDelivered =
    i18n.language == "en" ? "Your item is delivered." : "تم توصيل منتجك.";
  const justLikedItem =
    i18n.language == "en" ? "just liked your listing." : "أعجب بمنتجك.";
  const justRepliedComment =
    i18n.language == "en"
      ? "just replied to your comment."
      : "قام بالرد على تعليقك.";
  const justCommented =
    i18n.language == "en"
      ? "just commented on your product."
      : "علق على منتجك.";
  const justFollwed =
    i18n.language == "en" ? "just started following you!" : "بدأ في متابعتك!";
  const dispatch = useDispatch();
  const now = new Date();
  var datenow = new Date();
  datenow.setDate(now.getDate());
  const [bidUsers, setBidUsers] = useState({});
  console.log(bidUsers, "bidUsers");
  async function getBid11Messages() {
    try {
      const messagesRef = collection(db, "messages");
      const queries = [
        query(
          messagesRef,
          where("type", "==", "BID11"),
          where("idSender", "==", currentUser.uid)
        ),
        query(
          messagesRef,
          where("type", "==", "BID11"),
          where("idReceiver", "==", currentUser.uid)
        ),
      ];

      const [senderSnap, receiverSnap] = await Promise.all(
        queries.map(getDocs)
      );

      const allMessages = [
        ...senderSnap.docs.map((doc) => ({ id: doc.id, ...doc.data() })),
        ...receiverSnap.docs.map((doc) => ({ id: doc.id, ...doc.data() })),
      ];

      // Remove duplicates by ID
      return Array.from(
        new Map(allMessages.map((msg) => [msg.id, msg])).values()
      );
    } catch (error) {
      console.error("Error fetching messages:", error);
      return [];
    }
  }
  async function getUserDataById(userId) {
    try {
      const userRef = doc(db, "users", userId);
      const userSnap = await getDoc(userRef);
      return userSnap.exists() ? { id: userSnap.id, ...userSnap.data() } : null;
    } catch (error) {
      console.error("Error getting user:", error);
      return null;
    }
  }

  // Modified useEffect for notifications
  useEffect(() => {
    const fetchBidUsers = async () => {
      if (!notifications.length || !currentUser) return;

      try {
        const bidNotifications = notifications?.filter((notf) =>
          [
            NOTIFICATION_TYPE_BID_ACCEPTED,
            NOTIFICATION_TYPE_BID_REJECTED,
            NOTIFICATION_TYPE_BID_PRICE_COUNTER,
            NOTIFICATION_TYPE_BID_PRICE_FIRST,
          ].includes(notf?.type)
        );

        const messages = await getBid11Messages();
        if (!Array.isArray(messages)) throw new Error("Messages not an array");

        const newUsersData = {};
        const userCache = new Map();

        for (const notf of bidNotifications) {
          try {
            const bidId = notf?.content;
            const msg = messages?.find((m) => m?.content?.includes(bidId));
            const userId =
              msg?.idSender == currentUser?.uid
                ? msg?.idReceiver
                : msg?.idSender;

            if (userId) {
              if (!userCache?.has(userId)) {
                const user = await getUserDataById(userId);
                if (user) {
                  userCache?.set(userId, user);
                  // Store user data under both notification ID AND user ID
                  newUsersData[notf?.id] = user;
                  newUsersData[userId] = user; // Add this line
                }
              } else {
                newUsersData[notf?.id] = userCache?.get(userId);
              }
            }
          } catch (err) {
            console.error(
              "Error getting user for notification:",
              notf?.id,
              err
            );
          }
        }

        setBidUsers((prev) => ({ ...prev, ...newUsersData }));
      } catch (err) {
        console.error("Error in fetchBidUsers:", err);
      }
    };

    fetchBidUsers();
  }, [notifications, currentUser?.uid]);
  const getNotifProduct = async () => {
    try {
      if (notifications.length !== 0) {
        const productPromises = notifications.map(async (notf) => {
          const viewedRef = doc(db, "product", notf.content);
          const docSnapshot = await getDoc(viewedRef);
          if (docSnapshot.exists()) {
            const data = {
              id: docSnapshot.id,
              ...docSnapshot.data(),
            };

            return data;
          } else {
            return null;
          }
        });
        Promise.all(productPromises)
          .then((products) => {
            const validProducts = products.filter(
              (product) => product !== null
            );
            console.log("validProducts", validProducts);
            setProd(validProducts);
          })
          .catch((error) => {
            console.error("Error retrieving products:", error);
          });
      } else {
        dispatch(setProd([]));
      }
    } catch (e) {
      console.error(e);
    }
  };

  const getNotifProductRejected = async () => {
    try {
      if (notifications.length !== 0) {
        const productPromises = notifications.map(async (notf) => {
          const viewedRef = doc(db, "product", notf.content);
          const docSnapshot = await getDoc(viewedRef);

          if (docSnapshot.exists()) {
            const data = {
              id: docSnapshot.id,
              ...docSnapshot.data(),
            };

            if (
              data &&
              data.status === "Rejected" &&
              data.status !== "Deleted"
            ) {
              return data;
            } else {
              return null;
            }
          } else {
            return null;
          }
        });

        Promise.all(productPromises)
          .then((products) => {
            const validProducts = products.filter(Boolean);
            setProductsrRej(validProducts);
          })
          .catch((error) => {
            console.error("Error retrieving products:", error);
          });
      } else {
        dispatch(setProductsrRej([]));
      }
    } catch (e) {
      console.error(e);
    }
  };
  const getNotifProduct1 = async () => {
    try {
      if (notifications.length !== 0) {
        const productPromises = notifications.map(async (notf) => {
          const viewedRef = doc(db, "product", notf.content.split("#")[1]);
          const docSnapshot = await getDoc(viewedRef);
          if (docSnapshot.exists()) {
            const data = {
              id: docSnapshot.id,
              ...docSnapshot.data(),
            };

            return data;
          } else {
            return null;
          }
        });
        Promise.all(productPromises)
          .then((products) => {
            const validProducts = products.filter(
              (product) => product !== null
            );
            console.log("validProducts", validProducts);
            setProdsplit1(validProducts);
          })
          .catch((error) => {
            //console.error("Error retrieving products:", error);
          });
      } else {
        dispatch(setProdsplit1([]));
      }
    } catch (e) {
      console.error(e);
    }
  };
  useEffect(() => {
    if (notifications.length != 0) {
      getNotifProduct();
      getNotifProductRejected();
      getNotifProduct1();
      console.log("1");
    }
  }, [notifications]);

  useEffect(() => {
    const fetchData = async () => {
      var usr;
      if (notifications) {
        var userArray = [...users];
        for (const notification of notifications) {
          if (
            notification.type == NOTIFICATION_TYPE_LIKE_PRODUCT ||
            notification.type == NOTIFICATION_TYPE_FOLLOW ||
            notification.type == NOTIFICATION_TYPE_COMMENT_PRODUCT ||
            notification.type == NOTIFICATION_TYPE_COMMENT_REPLY
          ) {
            if (
              users.filter(
                (user) => user.id === notification.content.split("#")[0]
              ).length == 0 &&
              userArray.filter(
                (user) => user.id === notification.content.split("#")[0]
              ).length == 0
            ) {
              if (notification.content.split("#")[0].length != 0) {
                usr = await getUserDataById(notification.content.split("#")[0]);
                if (!userArray.some((item) => item.id === usr.id)) {
                  userArray.push(usr);
                }
              }
            }
          }
        }
        dispatch(GetAllUsers(userArray));
      }
    };
    if (notifications) {
      fetchData();
    }
  }, [notifications]);

  const DateNotification = (date) => {
    if ("toDate" in date) {
      var diff = (datenow - date.toDate()) / (1000 * 3600 * 24);
      if (diff < 1) {
        var t = (datenow - date.toDate()) / (1000 * 3600);
        if (t < 1) {
          var m = (datenow - date.toDate()) / (1000 * 60);
          if (m < 1) {
            var s = (datenow - date.toDate()) / 1000;
            return <>{Math.round(s)}s</>;
          } else {
            return <>{Math.round(m)}m</>;
          }
        } else {
          return <>{Math.round(t)}h</>;
        }
      } else {
        if (diff < 7) {
          return <>{Math.round(diff)}d</>;
        } else {
          if (diff < 30) {
            return <>{Math.round(diff / 7)}w</>;
          } else {
            if (diff < 365) {
              return <>{Math.floor(diff / 30)}mo</>;
            }
          }
        }
      }
    } else {
      return false;
    }
  };
  function NotificationLink(notf, setShow) {
    console.log(notf, "show here");
    if (
      notf.type == NOTIFICATION_TYPE_PRODUCT_ACCEPTED ||
      notf.type == NOTIFICATION_TYPE_PRODUCT_REJECTED ||
      notf.type == NOTIFICATION_TYPE_PRODUCT_AUTHENTICATING ||
      notf.type == NOTIFICATION_TYPE_PRODUCT_ORDER_PLACED ||
      notf.type == NOTIFICATION_TYPE_PRODUCT_DELIVERED ||
      notf.type == NOTIFICATION_TYPE_PRODUCT_SHIPPED ||
      notf.type == NOTIFICATION_TYPE_PRODUCT_DRIVER_PICKUP
    ) {
      <>
        {prod
          .filter((prod) => prod.id == notf.content)
          .map((prod) => (
            <>
              {navigate(`/product/${prod.id}`)}
              {setShow(false)}
            </>
          ))}
      </>;
    } else if (
      notf.type == NOTIFICATION_TYPE_LIKE_PRODUCT ||
      notf.type == NOTIFICATION_TYPE_COMMENT_PRODUCT ||
      NOTIFICATION_TYPE_COMMENT_REPLY
    ) {
      prodsplit1
        .filter((prod) => prod.id == notf.content.split("#")[1])
        .map((prod) => (
          <>
            {navigate(`/product/${prod.id}`)}
            {setShow(false)}
          </>
        ));
    } else if (
      notf.type == NOTIFICATION_TYPE_BID_ACCEPTED ||
      notf.type == NOTIFICATION_TYPE_BID_REJECTED ||
      notf.type == NOTIFICATION_TYPE_BID_PRICE_COUNTER ||
      notf.type == NOTIFICATION_TYPE_BID_PRICE_FIRST
    )
      return null;
    else if ((notf.type = NOTIFICATION_TYPE_FOLLOW)) {
      prodsplit1
        .filter((prod) => prod.id == notf.content.split("#")[1])
        .map((prod) => (
          <>
            {navigate(`/product/${prod.id}`)}
            {setShow(false)}
          </>
        ));
    } else if (notf.type == NOTIFICATION_TYPE_ORDER_DELIVERED) {
      prod
        .filter((prod) => prod.id == notf.content)
        .map((prod) => (
          <>
            {navigate(`/product/${prod.id}`)}

            {setShow(false)}
          </>
        ));
    }
  }
  function TypeStatus(type, notf, index) {
    if (
      type == NOTIFICATION_TYPE_BID_ACCEPTED ||
      type == NOTIFICATION_TYPE_BID_REJECTED ||
      type == NOTIFICATION_TYPE_BID_PRICE_COUNTER ||
      type == NOTIFICATION_TYPE_BID_PRICE_FIRST
    ) {
      console.log("Current bidUsers:", bidUsers);
      console.log("Notification ID:", notf?.id);

      const username = bidUsers[notf?.id]?.username || "Someone";

      console.log("Resolved username:", username);

      return type === NOTIFICATION_TYPE_BID_PRICE_FIRST
        ? `${username} sent you an offer`
        : type === NOTIFICATION_TYPE_BID_PRICE_COUNTER
        ? `${username} sent you a counter offer`
        : type === NOTIFICATION_TYPE_BID_REJECTED
        ? `${username} rejected your offer! Consider reducing your item's price.`
        : `Payment is due in 24h, or the deal will be canceled!`;
    } else {
      if (type == NOTIFICATION_TYPE_FOLLOW) {
        return justFollwed;
      } else {
        if (type == NOTIFICATION_TYPE_ORDER_DELIVERED) {
          return yourListingDelivered;
        } else {
          if (type == NOTIFICATION_TYPE_PRODUCT_ACCEPTED) {
            return yourListingAccepted;
          }
          if (type == NOTIFICATION_TYPE_PRODUCT_REJECTED) {
            return yourListingRejected;
          }
          if (type == NOTIFICATION_TYPE_PRODUCT_AUTHENTICATING) {
            return yourListingAuthenticate;
          }
          if (type == NOTIFICATION_TYPE_PRODUCT_AUTHENTICATING_FAILED) {
            return yourListingAuthenticateFail;
          }
          if (type == NOTIFICATION_TYPE_PRODUCT_ORDER_PLACED) {
            return yourListingOrdered;
          }
          if (type == NOTIFICATION_TYPE_PRODUCT_DELIVERED) {
            return yourListingDelivered;
          }
          if (type == NOTIFICATION_TYPE_PRODUCT_SHIPPED) {
            return yourListingShipped;
          }
          if (type == NOTIFICATION_TYPE_PRODUCT_DRIVER_PICKUP) {
            return yourListingPickup;
          } else {
            if (type == NOTIFICATION_TYPE_BALANCE_ACCEPTED) {
              return "Your Payout was accepted";
            }
            if (type == NOTIFICATION_TYPE_BALANCE_REJECTED) {
              return "Your Payout was declined.";
            } else {
              if (type == NOTIFICATION_TYPE_LIKE_PRODUCT) {
                return justLikedItem;
              } else {
                if (type == NOTIFICATION_TYPE_PRICE_DROP) {
                  return "A tip to sell faster! Seal a double-quick deal by lowering your item's price!";
                } else {
                  // price drop
                  if (type == NOTIFICATION_TYPE_PRODUCT_PRICE_DROP) {
                    return `This marvelous catch is now a total steal to snatch ⚡ Seize it first`;
                  } else {
                    if (type == NOTIFICATION_TYPE_COMMENT_PRODUCT) {
                      return justCommented;
                    } else {
                      if (type == NOTIFICATION_TYPE_COMMENT_REPLY) {
                        return justRepliedComment;
                      }
                    }
                  }
                  return;
                }
              }
            }
          }
        }
      }
    }
  }

  return currentUser == null ? (
    <>
      <div
        style={{
          zIndex: "10000",
        }}
        className={`notf_none_title pt-md-3 pb-3 ${
          i18n.language == "ar" && "text-startAr"
        }`}
      >
        {t("notf1")}
      </div>
      <hr className="dropdown-divider " />
      <div className={`notf_none ${i18n.language == "ar" && "text-startAr"}`}>
        {t("notf2")}
      </div>
    </>
  ) : notifications.filter((notif) => notif.toUid == currentUser.uid).length ==
    0 ? (
    <>
      <div
        className={`notf_none_title pt-md-3 pb-3 ${
          i18n.language == "ar" && "text-startAr"
        }`}
      >
        {t("notf1")}
      </div>
      <hr className="dropdown-divider " />
      <div className={`notf_none ${i18n.language == "ar" && "text-startAr"}`}>
        {t("notf2")}
      </div>
    </>
  ) : (
    <>
      <div
        style={{
          zIndex: "10000",
        }}
        className={`notf_none_title pt-md-3 pb-3 ${
          i18n.language == "ar" && "text-startAr"
        }`}
      >
        {t("notf1")}
      </div>
      <hr className="dropdown-divider " />

      {notifications
        .filter((notif) => notif.toUid == currentUser.uid)
        .sort((a, b) => b.date.seconds - a.date.seconds)
        .map((notf, index) => {
          // Skip rendering these notification types completely
          // if (
          //   // notf.type == NOTIFICATION_TYPE_BID_ACCEPTED ||
          //   // notf.type == NOTIFICATION_TYPE_BID_REJECTED ||
          //   // notf.type == NOTIFICATION_TYPE_BID_PRICE_COUNTER ||
          //   // notf.type == NOTIFICATION_TYPE_BID_PRICE_FIRST ||
          //   // notf.type == NOTIFICATION_TYPE_BALANCE_UPDATED ||
          //   // notf.type == NOTIFICATION_TYPE_BALANCE_REJECTED ||
          //   // notf.type == NOTIFICATION_TYPE_BALANCE_ACCEPTED ||
          //   // notf.type == NOTIFICATION_TYPE_PRODUCT_PRICE_DROP ||
          //   // notf.type == NOTIFICATION_TYPE_PRICE_DROP ||
          //   notf.type == NOTIFICATION_TYPE_ORDER_DELIVERED
          // ) {
          //   return null;
          // }

          // For all other notification types
          return (
            <React.Fragment
              style={{
                zIndex: "10000",
              }}
              key={notf?.id || Math.random().toString()}
            >
              <li
                className="align-items-center d-flex pt-2 pb-2"
                style={{ cursor: "pointer", zIndex: "10000" }}
                onClick={() => NotificationLink(notf, setShow)}
              >
                <div className="row mx-0 align-items-center d-flex w-100">
                  {/* Unread indicator */}
                  <div className="col-auto px-0">
                    {notf?.isOpened === false && (
                      <div className="circle-notofication"></div>
                    )}
                  </div>

                  {/* Image column */}
                  <div className="col-3 px-0 ps-3">
                    {(() => {
                      // Product Rejected notifications
                      if (notf?.type == NOTIFICATION_TYPE_PRODUCT_REJECTED) {
                        if (
                          productsrRej?.filter(
                            (prod) => prod.id == notf.content
                          ).length != 0
                        ) {
                          const product = productsrRej?.find(
                            (prod) => prod.id == notf.content
                          );
                          return (
                            <>
                              <img
                                key={product?.id}
                                src={product?.frontImage}
                                className="logo-notification"
                                id={product.id}
                                alt="logo-notification"
                              />
                            </>
                          );
                        } else if (
                          prod.filter((prod) => prod?.id == notf?.content)
                            ?.length != 0
                        ) {
                          const product = prod.find(
                            (prod) => prod?.id == notf?.content
                          );
                          return (
                            <img
                              key={product?.id}
                              src={product?.frontImage}
                              className="logo-notification"
                              id={product?.id}
                              alt="logo-notification"
                            />
                          );
                        }
                        return null;
                      }

                      // Product related notifications
                      else if (
                        notf.type == NOTIFICATION_TYPE_PRODUCT_ACCEPTED ||
                        notf.type == NOTIFICATION_TYPE_PRODUCT_AUTHENTICATING ||
                        notf.type == NOTIFICATION_TYPE_PRODUCT_ORDER_PLACED ||
                        notf.type == NOTIFICATION_TYPE_PRODUCT_DELIVERED ||
                        notf?.type == NOTIFICATION_TYPE_PRODUCT_SHIPPED ||
                        notf?.type == NOTIFICATION_TYPE_PRODUCT_DRIVER_PICKUP ||
                        notf?.type ==
                          NOTIFICATION_TYPE_PRODUCT_AUTHENTICATING_FAILED ||
                        notf?.type == NOTIFICATION_TYPE_BID_REJECTED ||
                        notf?.type == NOTIFICATION_TYPE_BID_ACCEPTED ||
                        notf?.type == NOTIFICATION_TYPE_BID_PRICE_COUNTER ||
                        notf?.type == NOTIFICATION_TYPE_BID_PRICE_FIRST ||
                        notf?.type == NOTIFICATION_TYPE_PRODUCT_PRICE_DROP
                      ) {
                        const product = prod?.find(
                          (p) => p?.id == notf?.content
                        );
                        //  if no product picture show the user profile pic
                        const user = bidUsers[notf?.id]?.photoURL;
                        return product ? (
                          <>
                            <img
                              key={product.id}
                              src={product.frontImage || avatar}
                              className="logo-notification"
                              id={product.id}
                              alt="logo-notification"
                            />
                          </>
                        ) : (
                          // showing images fron notification collection if productFrontImage avilable
                          <>
                            <img
                              key={product?.id}
                              src={notf?.productFrontImage || user || avatar}
                              className="logo-notification"
                              id={product?.id}
                              alt="logo-notification"
                            />
                          </>
                        );
                      }

                      // User activity notifications
                      else if (
                        notf.type == NOTIFICATION_TYPE_LIKE_PRODUCT ||
                        notf.type == NOTIFICATION_TYPE_COMMENT_PRODUCT ||
                        NOTIFICATION_TYPE_COMMENT_REPLY
                      ) {
                        const user = users.find(
                          (u) => u.id == notf.content.split("#")[0]
                        );
                        return user ? (
                          user.photoURL ? (
                            <img
                              key={user.id}
                              src={user.photoURL}
                              className="logo-notification"
                              id={user.id}
                              alt="logo-notification"
                            />
                          ) : (
                            <img
                              key={user.id}
                              src={avatar}
                              className="logo-notification"
                              alt="logo-notification"
                            />
                          )
                        ) : null;
                      }

                      // Follow notifications
                      else if (notf.type == NOTIFICATION_TYPE_FOLLOW) {
                        const user = users.find(
                          (u) => u.id == notf.content.split("#")[0]
                        );
                        return user ? (
                          user.photoURL ? (
                            <img
                              key={user.id}
                              src={user.photoURL}
                              className="logo-notification"
                              id={user.id}
                              alt="logo-notification"
                            />
                          ) : (
                            <img
                              key={user.id}
                              src={avatar}
                              className="logo-notification"
                              alt="logo-notification"
                            />
                          )
                        ) : null;
                      }

                      return null;
                    })()}
                  </div>

                  {/* Text content */}
                  <div
                    className="col-6 txt-notopend px-0 w-full"
                    style={{
                      width: "70%",
                    }}
                  >
                    {(() => {
                      // User-related notifications
                      if (
                        notf.type == NOTIFICATION_TYPE_LIKE_PRODUCT ||
                        notf.type == NOTIFICATION_TYPE_COMMENT_PRODUCT ||
                        notf.type == NOTIFICATION_TYPE_COMMENT_REPLY ||
                        notf.type == NOTIFICATION_TYPE_FOLLOW ||
                        notf.type == NOTIFICATION_TYPE_PRODUCT_ACCEPTED ||
                        notf.type == NOTIFICATION_TYPE_PRODUCT_AUTHENTICATING ||
                        notf.type == NOTIFICATION_TYPE_PRODUCT_ORDER_PLACED ||
                        notf.type == NOTIFICATION_TYPE_PRODUCT_DELIVERED ||
                        notf?.type == NOTIFICATION_TYPE_PRODUCT_SHIPPED ||
                        notf?.type == NOTIFICATION_TYPE_PRODUCT_DRIVER_PICKUP ||
                        notf?.type ==
                          NOTIFICATION_TYPE_PRODUCT_AUTHENTICATING_FAILED ||
                        notf?.type == NOTIFICATION_TYPE_BID_REJECTED ||
                        notf?.type == NOTIFICATION_TYPE_BID_ACCEPTED ||
                        notf?.type == NOTIFICATION_TYPE_BID_PRICE_COUNTER ||
                        notf?.type == NOTIFICATION_TYPE_BID_PRICE_FIRST
                      ) {
                        const user = users.find(
                          (u) =>
                            u.id == (notf.fromUid || notf.content.split("#")[0])
                        );
                        return user ? (
                          <span key={user.id}>@{user.username}</span>
                        ) : null;
                      }
                      return null;
                    })()}
                    {/* offer rejected case heading */}
                    {notf?.type == NOTIFICATION_TYPE_BID_REJECTED && (
                      <p
                        className="mb-0"
                        style={{
                          fontWeight: "500",
                          fontSize: "14px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Offer Unsuccessful 🔔
                      </p>
                    )}
                    {/* offer accepted case heading  */}
                    {notf?.type == NOTIFICATION_TYPE_BID_ACCEPTED && (
                      <p
                        className="mb-0"
                        style={{
                          fontWeight: "500",
                          fontSize: "14px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        The offer was accepted ❤️‍🔥
                      </p>
                    )}
                    {/* price derop heading  */}
                    {notf?.type == NOTIFICATION_TYPE_PRODUCT_PRICE_DROP && (
                      <p
                        className="mb-0"
                        style={{
                          fontWeight: "500",
                          fontSize: "14px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Price DROP 😍
                      </p>
                    )}
                    <p
                      className="mb-0 w-full"
                      style={{
                        fontWeight: "400",
                        fontSize: "12px",
                        width: "100%",
                      }}
                    >
                      {TypeStatus(notf.type, notf, index)}
                    </p>
                    <div className="txt-notification2 pt-1">
                      {DateNotification(notf.date)} ago
                    </div>
                  </div>

                  <div className="col-2 ps-3 px-0"></div>
                </div>
              </li>
              <hr className="dropdown-divider" />
            </React.Fragment>
          );
        })}
    </>
  );
}

export default NotificationMap;
